import { useEffect } from 'react'
import { ROOT_URL } from 'gatsby-env-variables'
import ROUTES from 'Routes'
import If from '@mobi/components/If'
import SEO from 'components/Seo'
import ResetBaseButton from 'components/ResetBaseButton'
import FeatureToggleWidget from 'components/FeatureToggleWidget'
import featureToggle from 'utils/featureToggle'
import { removeGatsbyFocusWrapperTabIndex } from 'utils/accessibility'
import analyticsUuid from 'utils/analyticsUuid'
import { handleSourceOrigin } from 'utils/isSourceOrigin'
import isClient from 'utils/isClient'
const { resetCpf } = featureToggle()
import './LandingLayout.scss'
import { addVariablesGTM } from 'utils/trackings/addVariablesGTM'
import useGetVWOVariant from 'hooks/useGetVWOVariant'

const LandingLayout = ({ children }) => {
  useEffect(() => {
    removeGatsbyFocusWrapperTabIndex()

    analyticsUuid.createAnalyticsUuid()
    handleSourceOrigin()

    addVariablesGTM()
  }, [])

  const isCardInfosAbTestVariant =
    useGetVWOVariant({ name: 'tela_conclusao_card_infos' }) === '1'

  useEffect(() => {
    if (isCardInfosAbTestVariant) {
      const url = new URL(window.location.href)

      url.searchParams.set('card_info_conclusion_variant', 'true')

      window.history.pushState({ path: url.href }, '', url.href)
    }
  }, [isCardInfosAbTestVariant])

  const handleMetaRobots = () => {
    const noIndexNoFollowRoutes = ['/lojasavenida', '/cpf']

    if (
      isClient() &&
      noIndexNoFollowRoutes.includes(window.location.pathname)
    ) {
      return 'noindex, nofollow'
    }
  }

  const handleCpfRouteRedirect = () => {
    if (isClient() && window.location.pathname === '/cpf') {
      return {
        'http-equiv': 'refresh',
        content: `2;url=${ROOT_URL}${ROUTES.register.path}`,
      }
    }
  }

  return (
    <div className="app-layout">
      <SEO
        keywords="Negociação de dívidas, limpar o nome, renegociar dívida, aumentar score, feirão limpa nome, recovery"
        faviconHref="Favicon.ico"
        metaRobots={handleMetaRobots()}
        meta={{
          ...handleCpfRouteRedirect(),
        }}
      />
      <main className="main-content">{children}</main>

      <If condition={resetCpf} renderIf={<ResetBaseButton />} />
      <FeatureToggleWidget />
    </div>
  )
}

export default LandingLayout
